export const pageSeo = {
  "/intellegence-market-solutions": {
    title: "Drone Planet – Best Intelligence Drone Software Plans India",
    description:
      "Explore best intelligence drone software and SaaS plans at Drone Planet India. Buy AeroMegh Pro, Business and Enterprise plans for data intelligence.",
    canonical:
      "https://droneplanet.in/intellegence-market-solutions",
  },

  "/drone-parts": {
    title: "Best Place to Buy Drone Parts in India – Drone Planet",
    description:
      "Drone Planet best place to buy drone parts online in India. Shop drone battery, motor, propellers, GPS, flight controller and agriculture drone spare parts.",
    canonical: "https://droneplanet.in/drone-parts",
  },

  "/training-courses/0": {
    title:
      "Drone Training Courses Institutes & Service Centers India – Drone Planet",
    description:
      "Drone Planet offers best drone training courses, certified institutes and service centers across India. DGCA RPC training with 100% placement and hostel support.",
    canonical: "https://droneplanet.in/training-courses/0",
  },

  "/taas": {
    title: "Discover Drone Tenders & RFP Bids in India – Drone Planet",
    description:
      "Find latest drone tenders and government RFP bids in India at Drone Planet. Browse agri, surveillance, defense, DaaS and drone parts supply tenders easily.",
    canonical: "https://droneplanet.in/taas",
  },

  "/daas-service-page": {
    title:
      "Drone Services & Projects Marketplace in India – Drone Planet",
    description:
      "Drone Planet drone services and projects marketplace in India. Connect with verified drone vendors for crop spraying, aerial survey, inspection and photography.",
    canonical: "https://droneplanet.in/daas-service-page",
  },

  "/jobs-hire-page": {
    title: "Drone Pilot Jobs & Hiring in India – Drone Planet",
    description:
      "Find latest drone pilot and technician jobs in India at Drone Planet. Browse drone operator, DGCA instructor, UAV pilot and drone services job openings.",
    canonical: "https://droneplanet.in/jobs-hire-page",
  },

  "/aboutdaas": {
    title:
      "Drone Services in India – Connect Operators & Clients",
    description:
      "Find drone services in India at Drone Planet marketplace. Connect with 500+ verified drone operators for aerial photography, inspection, mapping and agriculture.",
    canonical: "https://droneplanet.in/aboutdaas",
  },

  "/dsk": {
    title:
      "Drone Suvidha Kendra – Start Drone Spraying Business",
    description:
      "Join Drone Suvidha Kendra and start agriculture drone spraying business in India. Government supported scheme with DGCA training and high earning potential.",
    canonical: "https://droneplanet.in/dsk",
  },

  "/DroneXplore": {
    title:
      "Drone Planet – Buy Premium Drones & Get Drone Training",
    description:
      "Buy premium drones and get DGCA drone training in India at Drone Planet. Find drone jobs, hire professional drone pilot and explore drone career opportunities.",
    canonical: "https://droneplanet.in/DroneXplore",
  },

  "/faqs": {
    title: "Frequently Asked Questions – Drone Planet India",
    description:
      "Get answers to common drone questions at Drone Planet. Find FAQs on agriculture drones, orders, shipping, returns, flight checker and drone regulations India.",
    canonical: "https://droneplanet.in/faqs",

    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What types of drones do you sell?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We offer a wide range of drones, including models for agriculture, photography, surveying, and nano drones.",
          },
        },
        {
          "@type": "Question",
          name: "How do I choose the right drone for me?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Use our comparison tool to evaluate different models side-by-side.",
          },
        },
        {
          "@type": "Question",
          name: "Are your drones beginner-friendly?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Some models are designed for beginners while others are for professionals.",
          },
        },
        {
          "@type": "Question",
          name: "Are replacement parts or accessories available?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer controllers, motors, propellers, batteries and more.",
          },
        },
        {
          "@type": "Question",
          name: "How do I know where I can legally fly my drone?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Use our Flight Tracker Tool to view permitted and restricted airspaces.",
          },
        },
      ],
    },
  },
};